// src/components/menus/PerformanceDashboardSubMenu.tsx
import React from 'react';
import { BeingsPageSubMenuButton } from '../common/Buttons';
import { SubMenuContainer, SubMenuCap } from './shared/MenuElements';

export const PERFORMANCE_TAB_IDS = ['backend', 'frontend'] as const;
export type PerformanceTabId = (typeof PERFORMANCE_TAB_IDS)[number];

interface PerformanceDashboardSubMenuProps {
  selectedTab: PerformanceTabId;
  setSelectedTab: (tab: PerformanceTabId) => void;
  bottomBorder?: boolean;
  buttonBottomBorder?: boolean;
}

const PerformanceDashboardSubMenu: React.FC<
  PerformanceDashboardSubMenuProps
> = ({
  selectedTab,
  setSelectedTab,
  bottomBorder = true,
  buttonBottomBorder = false,
}) => (
  <SubMenuContainer bottomBorder={bottomBorder}>
    <BeingsPageSubMenuButton
      onClick={() => setSelectedTab('backend')}
      isActive={selectedTab === 'backend'}
      minWidth="158px"
      showBottomBorder={buttonBottomBorder}
    >
      BACKEND
    </BeingsPageSubMenuButton>

    <BeingsPageSubMenuButton
      onClick={() => setSelectedTab('frontend')}
      isActive={selectedTab === 'frontend'}
      minWidth="158px"
      showBottomBorder={buttonBottomBorder}
    >
      FRONTEND
    </BeingsPageSubMenuButton>

    <SubMenuCap />
  </SubMenuContainer>
);

export default PerformanceDashboardSubMenu;
